




















import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

export default Vue.extend({
  name: 'SystemDialog',
  computed: {
    ...mapState('components/system-dialog', [
      'header',
      'paragraphs',
      'approveButton',
      'cancelButton'
    ]),
    dialogProps() {
      const cancelButton = this.cancelButton
        ? {
            'cancel-name': this.cancelButton.text,
            'cancel-button-class': 'normal-link-button',
            'cancel-button-color': 'primary',
            'cancel-button-text': this.cancelButton.type === 'link'
          }
        : null;

      const approveButton = this.approveButton
        ? {
            'approve-name': this.approveButton.text
          }
        : null;
      return {
        header: this.header,
        ...cancelButton,
        ...approveButton
      };
    },
    show() {
      return !!this.header;
    }
  },
  methods: {
    ...mapMutations('components/system-dialog', ['clear']),
    onChange(approved) {
      const button = approved ? this.approveButton : this.cancelButton;
      const { to, intercom } = button;
      if (to) window.open(to);
      else if (intercom) this.$intercom.openChat(intercom);
      this.clear();
    }
  }
});
